import { createRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '@/router/root-route';

// O hub de edição foi absorvido pela tela "Gestão de vaga" (EU-560):
// `/vagas/$jobId/editar` e `/vagas/$jobId` viraram a mesma coisa.
// A rota permanece SÓ como redirect (links antigos, bookmarks, histórico);
// as SUBSEÇÕES de edição (`/vagas/$jobId/editar/<seção>`) continuam vivas.
const editSearchSchema = z.object({
  copy: z.boolean().optional(),
});

export const jobEditRedirectRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/$jobId/editar',
  validateSearch: editSearchSchema,
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/vagas/$jobId', params });
  },
});
